import { ArrowFillRightIcon, css, styled } from 'canoe';
import React from 'react';

const DraggingLayer = styled.div<{ isDragging?: boolean }>`
  ${({ isDragging }) => css`
    position: absolute;
    z-index: -1;
    overflow: hidden;
    visibility: hidden;
    left: -9999px;
    ${isDragging &&
    css`
      visibility: visible;
    `}
  `}
`;

const DraggedItem = styled.button`
  ${({ theme }) => css`
    position: relative;
    outline: none;
    border: 0;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    border-radius: ${theme.borderRadius.small};
    height: 35px;
    width: 300px;
    opacity: 0.9;
    background: ${theme.colors.BrandPurple};
    color: ${theme.colors.White};
    cursor: grabbing;
  `}
`;

type DragNodeProps = {
  dragNodeTraits: {
    nodeLabel: string;
    isCanvas: boolean;
  }[];
  isDragging: boolean;
};
export const DragNode = React.forwardRef(
  ({ isDragging, dragNodeTraits }: DragNodeProps, ref: React.RefObject<HTMLDivElement>) => {
    return (
      <DraggingLayer ref={ref} isDragging={isDragging} data-cy="dragged-preview">
        {dragNodeTraits?.map((dragNodeTrait, idx) => {
          return (
            <DraggedItem key={idx.toString()}>
              {dragNodeTrait.isCanvas && <ArrowFillRightIcon color="White" size="s" mr="xxs" />}
              {dragNodeTrait.nodeLabel}
            </DraggedItem>
          );
        })}
      </DraggingLayer>
    );
  },
);
